import { Platform } from '@ionic/angular';
import { PlatformService } from '../services/platform/platform.service';

export enum PlatformEnum {
  ANDROID = 'android',
  IOS = 'ios',
  BROWSER = 'browser'
}

export function identifyPlatform(platform: Platform): PlatformEnum {
  //Retrofit this to use the platform service
  const platformService = new PlatformService(platform);
  return platformService.getPlatform();
}
